// Convert time to hours and minutes
export const calcTime = time => {
  if (!time) return '—';
  const hours = Math.floor(time / 60);
  const mins = time % 60;
  return hours ? `${hours}h ${mins}m` : `${mins}m`;
};
// Convert a number to money formatting
export const convertMoney = money => {
  if (!money) return '—';
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  return formatter.format(money);
};
// Compact money, e.g. $1.2B
export const compactMoney = money => {
  if (!money) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1
  }).format(money);
};

export const getYear = date => (date ? date.slice(0, 4) : '');

export const formatDate = date => {
  if (!date) return '—';
  const d = new Date(`${date}T00:00:00`);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatRating = rating =>
  rating ? Number(rating).toFixed(1) : 'NR';

// Two letters used for image placeholders
export const initials = (text = '') =>
  text
    .replace(/[^\p{L}\p{N}\s]/gu, '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join('') || '?';

// First letter used to index a title A–Z ("#" for numbers/symbols)
export const indexLetter = (title = '') => {
  const first = title
    .replace(/^(the|a|an)\s+/i, '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .charAt(0)
    .toUpperCase();
  return /[A-Z]/.test(first) ? first : '#';
};

export const sortTitle = (title = '') =>
  title.replace(/^(the|a|an)\s+/i, '').trim();

export const isPersistedState = stateName => {
  try {
    const sessionState = sessionStorage.getItem(stateName);
    return sessionState && JSON.parse(sessionState);
  } catch (error) {
    return null;
  }
};

export const persistState = (stateName, state) => {
  try {
    sessionStorage.setItem(stateName, JSON.stringify(state));
  } catch (error) {
    // Storage may be full or unavailable (private mode) — safe to ignore
  }
};
